import React from 'react';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';

interface Props {
  value: string;
  onCopy: (text: string) => void;
}

export default function TruncatedIdCell({ value, onCopy }: Props) {
  if (!value || value === '-') {
    return <Typography variant="body2">-</Typography>;
  }

  const truncated = value.substring(0, 8);
  const needsTruncation = value.length > 8;

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Tooltip title={value}>
        <Typography variant="body2" fontFamily="monospace">
          {truncated}
          {needsTruncation && '…'}
        </Typography>
      </Tooltip>
      <Tooltip title="Copy full ID">
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onCopy(value);
          }}
          sx={{ p: 0.25 }}
        >
          <ContentCopyIcon sx={{ fontSize: 14 }} />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
